"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1088],{

/***/ 21088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _microsoft_applicationinsights_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76833);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY = "3da5c312-ca69-48fe-94e1-fa4444704bfc";
var AzureApplicationInsights = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // init application insights
        // Initialize Azure Application Insights
        if (window && AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY && !window.appInsights) {
            window.appInsights = new _microsoft_applicationinsights_web__WEBPACK_IMPORTED_MODULE_1__/* .Initialization */ .u({
                config: {
                    instrumentationKey: AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY
                }
            });
            window.appInsights.loadAppInsights();
            window.appInsights.trackPageView();
        }
    }, []);
    return null;
};
/* harmony default export */ __webpack_exports__["default"] = (AzureApplicationInsights);


/***/ })

}]);